var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "order-panel" },
    [
      _c("div", { staticClass: "top-bar" }, [
        _c(
          "div",
          { staticClass: "top-left" },
          [
            _c(
              "a-button",
              {
                attrs: { size: "small", icon: "arrow-left" },
                on: { click: _vm.handleBack },
              },
              [_vm._v("返回")]
            ),
            _c("span", { staticClass: "top-table" }, [
              _vm._v(_vm._s(_vm.tableLabel)),
            ]),
            _vm.order
              ? [
                  _c("span", { staticClass: "top-order-no" }, [
                    _vm._v(_vm._s(_vm.order.order_no)),
                  ]),
                  _c(
                    "a-tag",
                    { attrs: { color: _vm.statusColor(_vm.order.status) } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.order.statusText ||
                            _vm.statusText(_vm.order.status)
                        )
                      ),
                    ]
                  ),
                ]
              : _c("a-tag", { attrs: { color: "orange" } }, [_vm._v("开台中")]),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "top-right" },
          [
            _vm.storeName
              ? _c("span", { staticClass: "top-store" }, [
                  _vm._v(_vm._s(_vm.storeName)),
                ])
              : _vm._e(),
            _c("span", { staticClass: "top-user" }, [
              _vm._v(_vm._s(_vm.userName)),
            ]),
            _c(
              "a-button",
              {
                attrs: { size: "small", disabled: !_vm.parkable },
                on: { click: _vm.handlePark },
              },
              [_vm._v("挂单")]
            ),
            _c(
              "a-button",
              {
                attrs: {
                  size: "small",
                  type: "primary",
                  disabled: !_vm.settleable,
                },
                on: { click: _vm.handleSettle },
              },
              [_vm._v("结账")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "menu-side" }, [
          _c(
            "div",
            { staticClass: "cat-list" },
            [
              _c(
                "div",
                {
                  staticClass: "cat-item",
                  class: { active: _vm.activeCategory === 0 },
                  on: {
                    click: function ($event) {
                      return _vm.switchCategory(0)
                    },
                  },
                },
                [_vm._v("全部")]
              ),
              _vm._l(_vm.flatCategories, function (c) {
                return _c(
                  "div",
                  {
                    key: c.id,
                    staticClass: "cat-item",
                    class: { active: _vm.activeCategory === c.id },
                    style: { paddingLeft: 14 + c.level * 12 + "px" },
                    on: {
                      click: function ($event) {
                        return _vm.switchCategory(c.id)
                      },
                    },
                  },
                  [_vm._v(_vm._s(c.name))]
                )
              }),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "goods-area" }, [
          _c(
            "div",
            { staticClass: "goods-search" },
            [
              _c("a-input-search", {
                attrs: { placeholder: "搜索菜品名称", allowClear: "" },
                on: { search: _vm.loadMenu },
                model: {
                  value: _vm.searchKey,
                  callback: function ($$v) {
                    _vm.searchKey = $$v
                  },
                  expression: "searchKey",
                },
              }),
            ],
            1
          ),
          _vm.goods.length
            ? _c(
                "div",
                { staticClass: "goods-scroll" },
                _vm._l(_vm.goods, function (g) {
                  return _c(
                    "div",
                    {
                      key: g.id,
                      staticClass: "goods-card",
                      class: { soldout: _vm.isSoldOut(g) },
                      on: {
                        click: function ($event) {
                          return _vm.onGoodsClick(g)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "goods-img" }, [
                        g.imgName
                          ? _c("img", {
                              attrs: { src: _vm.imgUrl(g.imgName), alt: "" },
                            })
                          : _c("span", { staticClass: "img-holder" }, [
                              _vm._v(
                                _vm._s(
                                  g.materialName ? g.materialName[0] : "菜"
                                )
                              ),
                            ]),
                      ]),
                      _c("div", { staticClass: "goods-info" }, [
                        _c("div", { staticClass: "goods-name" }, [
                          _vm._v(_vm._s(g.materialName)),
                        ]),
                        g.description
                          ? _c("div", { staticClass: "goods-desc" }, [
                              _vm._v(_vm._s(g.description)),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "goods-bottom" },
                          [
                            _c("span", { staticClass: "goods-price" }, [
                              _vm._v("¥" + _vm._s(_vm.fmt(g.minPrice))),
                            ]),
                            _vm.isSoldOut(g)
                              ? _c("a-tag", { attrs: { color: "red" } }, [
                                  _vm._v("估清"),
                                ])
                              : (g.options || []).length
                              ? _c("span", { staticClass: "goods-opt" }, [
                                  _vm._v("可选规格"),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            : !_vm.menuLoading
            ? _c("div", { staticClass: "goods-empty" }, [
                _vm._v("该分类暂无在售菜品"),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "cart-side" }, [
          _c("div", { staticClass: "cart-title" }, [_vm._v("已点清单")]),
          _c(
            "div",
            { staticClass: "cart-scroll" },
            [
              _vm.orderItems.length
                ? [
                    _c("div", { staticClass: "cart-group-label" }, [
                      _vm._v("已下单（金额为后端计价）"),
                    ]),
                    _vm._l(_vm.orderItems, function (it) {
                      return _c(
                        "div",
                        { key: it.id, staticClass: "cart-line saved" },
                        [
                          _c("div", { staticClass: "line-main" }, [
                            _c(
                              "div",
                              { staticClass: "line-name" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(it.material_name) +
                                    "\n                "
                                ),
                                it.item_status === "added"
                                  ? _c(
                                      "a-tag",
                                      { attrs: { color: "orange" } },
                                      [_vm._v("加菜")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm.optionsText(it.options_json)
                              ? _c("div", { staticClass: "line-sub" }, [
                                  _vm._v(
                                    _vm._s(_vm.optionsText(it.options_json))
                                  ),
                                ])
                              : _vm._e(),
                            it.remark
                              ? _c("div", { staticClass: "line-sub" }, [
                                  _vm._v("备注：" + _vm._s(it.remark)),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "line-right" }, [
                            _c("div", { staticClass: "line-qty" }, [
                              _vm._v("×" + _vm._s(it.quantity)),
                            ]),
                            _c("div", { staticClass: "line-amount" }, [
                              _vm._v("¥" + _vm._s(_vm.fmt(it.all_price))),
                            ]),
                          ]),
                        ]
                      )
                    }),
                  ]
                : _vm._e(),
              _vm.cart.length
                ? [
                    _c("div", { staticClass: "cart-group-label" }, [
                      _vm._v("待下单（价格为参考价）"),
                    ]),
                    _vm._l(_vm.cart, function (line, idx) {
                      return _c(
                        "div",
                        { key: line.key, staticClass: "cart-line" },
                        [
                          _c("div", { staticClass: "line-main" }, [
                            _c("div", { staticClass: "line-name" }, [
                              _vm._v(_vm._s(line.materialName)),
                            ]),
                            line.optionText
                              ? _c("div", { staticClass: "line-sub" }, [
                                  _vm._v(_vm._s(line.optionText)),
                                ])
                              : _vm._e(),
                            line.remark
                              ? _c("div", { staticClass: "line-sub" }, [
                                  _vm._v("备注：" + _vm._s(line.remark)),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "qty-step" },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.decQty(idx)
                                      },
                                    },
                                  },
                                  [_vm._v("-")]
                                ),
                                _c("span", { staticClass: "qty-num" }, [
                                  _vm._v(_vm._s(line.quantity)),
                                ]),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        line.quantity++
                                      },
                                    },
                                  },
                                  [_vm._v("+")]
                                ),
                                _c("a-button", {
                                  staticClass: "line-del",
                                  attrs: {
                                    size: "small",
                                    type: "danger",
                                    icon: "close",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.cart.splice(idx, 1)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "line-right" }, [
                            _c("div", { staticClass: "line-amount" }, [
                              _vm._v(
                                "¥" +
                                  _vm._s(_vm.fmt(line.unitRef * line.quantity))
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                  ]
                : _vm._e(),
              !_vm.orderItems.length && !_vm.cart.length
                ? _c("div", { staticClass: "cart-empty" }, [
                    _vm._v("尚未点餐，点击左侧菜品开始点餐"),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "cart-footer" },
            [
              _c("div", { staticClass: "total-row" }, [
                _c("span", [_vm._v("已下单：")]),
                _c("span", { staticClass: "total-num" }, [
                  _vm._v("¥" + _vm._s(_vm.fmt(_vm.savedTotal))),
                ]),
              ]),
              _vm.cart.length
                ? _c("div", { staticClass: "total-row" }, [
                    _c("span", [_vm._v("待下单（参考）：")]),
                    _c("span", { staticClass: "total-num" }, [
                      _vm._v("¥" + _vm._s(_vm.fmt(_vm.cartTotal))),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    size: "large",
                    block: "",
                    loading: _vm.submitting,
                    disabled: !_vm.canSubmit,
                  },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("下单")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("GoodsOptionsModal", {
        attrs: { visible: _vm.modalVisible, goods: _vm.modalGoods },
        on: {
          confirm: _vm.onModalConfirm,
          cancel: function ($event) {
            _vm.modalVisible = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }